module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.id,
      staticClass: "post"
    }, [_c('h3', [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [(post) ? _c('span', {
      staticClass: "category"
    }, [_vm._v(_vm._s(post.category.category))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(post.date))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "big-btn blue",
      attrs: {
        "to": {
          path: '/admin/posts/' + post.id
        }
      }
    }, [_vm._v("\n          Edit Post\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "big-btn red",
      attrs: {
        "href": ";javascript"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(post)
        }
      }
    }, [_vm._v("Delete Post")])], 1)
  }), _vm._v(" "), (!_vm.hideMore) ? _c('p', [_c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._v("\n          More ->\n        ")])]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75789ba4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/ManagePosts.vue
// module id = 515
// module chunks = 1